import React from 'react';
import styled from '@emotion/styled';

const OverlayContainer = styled.div`
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    background-color: rgba(141, 154, 165,0.5);
    position: absolute;
    z-index: 5;
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px;
    justify-content: space-between;
    position: absolute;
    width: 399px;
    height: 180px;
    left: 45%;
    top: 45%;
    z-index: 50;

    /* default/shade/white */

    background-color: #FFFFFF;
    /* default/gray/200 */

    border: 1px solid #EDF0F2;
    box-sizing: border-box;
    border-radius: 12px;
`;

const CardTitle = styled.h2`
    position: static;
    width: 192px;
    height: 20px;
    left: 32px;
    top: 32px;

    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */

    display: flex;
    align-items: center;
    color: #000;
`;
const CardText = styled.p`
    position: static;
    width: 335px;
    height: 16px;
    left: 0px;
    top: 0px;
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    color: #000;
`;
const ConfirmButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;
    justify-content: center;
    position: static;
    /* width: 52px; */
    left: 0px;
    top: 0px;
    color: white;
    /* Company Dark */
    font-family: Inter,sans-serif;
    background: #049CBE;
    border-radius: 6px;
    cursor: pointer;
`;

const CancelButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;
    justify-content: center;
    position: static;
    /* width: 52px; */
    left: 0px;
    top: 0px;
    border: 1px solid;
    /* Company Dark */
    font-family: Inter,sans-serif;
    background: #fff;
    border-radius: 6px;
    cursor: pointer;
`;

const ReviewOverlayComponent = ({setConfirm, setCancel}) => {
    const handleConfirmClose = () => {
        setConfirm(false);
        setCancel(true);
    }
    const handleCancelClose = () => {
        setConfirm(false);
        setCancel(false);
    }

    return (

        <OverlayContainer>
            <CardContainer>
                <CardTitle>Delete Confirmation</CardTitle>
                <CardText>Are you sure you want to delete this review?</CardText>
                <div style={{display: 'flex',flexDirection:'row', justifyContent:'space-between', marginTop:'0.5rem', width: '100%'}}>
                    <ConfirmButton onClick={() => setConfirm()}>Yes</ConfirmButton>
                    <CancelButton onClick={() => setCancel(false)}>No</CancelButton>
                </div>
            </CardContainer>
        </OverlayContainer>

    );
};



export default ReviewOverlayComponent;